import Immutable from "seamless-immutable";

const initialState = Immutable({});

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default AuthReducer;
